import PropTypes                from 'prop-types';

const ApplicationContent = props => {

    return (
        <div className={ `application-wrapper-content${props.screenMode ? ' full' : ''}` }>
            { props.children }
        </div>
    )
}

ApplicationContent.propTypes = {
    screenMode: PropTypes.string,
    children: PropTypes.node
};

export default ApplicationContent